import React from 'react';
import { Section, SectionHeader } from '../ui/Section';
import { motion } from 'framer-motion';
interface Genius {
  name: string;
  description: string;
  image: string;
  color: string;
}
const geniuses: Genius[] = [{
  name: 'Marie Curie',
  description: 'La mujer que iluminó la ciencia.',
  image: 'https://cdn.magicpatterns.com/uploads/uK85ybCbb6iAFjSqYcvGVD/2BC06BD2-F572-4219-8E0A-0E99E0A56E84.png',
  color: 'bg-[#E6DCCF]'
}, {
  name: 'Steve Jobs',
  description: 'El visionario que reinventó la tecnología.',
  image: 'https://cdn.magicpatterns.com/uploads/px7fAUw9M8qUjSCaJ73X8c/B9401D46-D31A-4D91-ADB6-E466157C0AED.png',
  color: 'bg-[#E6DCCF]'
}, {
  name: 'Isaac Newton',
  description: 'El genio que reveló las leyes del universo.',
  image: 'https://cdn.magicpatterns.com/uploads/u8Z8j1coib647at6uLvXTe/BBAB052F-5F74-49F9-A476-F29A03B85293.png',
  color: 'bg-[#E6DCCF]'
}];
export function GeniusesSection() {
  return <Section background="cream-dark" id="maestros" data-id="element-36">
      <SectionHeader title="Conoce a los Maestros" subtitle="Tres figuras históricas que redefinieron lo que es posible." data-id="element-37" />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-38">
        {geniuses.map((genius, index) => <motion.div key={genius.name} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 border border-[#E0D8D0]" data-id="element-39">
            <div className={`aspect-square overflow-hidden relative ${genius.color}`} data-id="element-40">
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" data-id="element-41"></div>

              <img src={genius.image} alt={genius.name} className="w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-700" data-id="element-42" />
            </div>

            <div className="p-8" data-id="element-43">
              <h3 className="text-2xl font-serif font-bold text-[#3D2314] mb-3 group-hover:text-[#C9A227] transition-colors" data-id="element-44">
                {genius.name}
              </h3>
              <p className="text-[#5C3D2E] leading-relaxed" data-id="element-45">
                {genius.description}
              </p>
            </div>
          </motion.div>)}
      </div>
    </Section>;
}